export default __webpack_public_path__ + "static/media/icon-instagram.adeb14e3.svg";